import { createApp } from 'vue'
import store from 'store'

import ShopFilterContainer from './ShopFilterContainer.vue'

const el = '.nti-component--shop-filter'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        const app = createApp(ShopFilterContainer)
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}